// EMBER 8 MODULAR CART FUNCTIONALITY
// Updated with correct VARIANT IDs (not product IDs)

// Product mapping - checkbox ID to Shopify VARIANT ID and details
const productMap = {
  'essential': {
    id: '52257770569941',
    name: 'Comprehensive Foundational Lab Panel',
    price: 450
  },
  'nutrition': {
    id: '52258788835541',
    name: 'Advanced Nutrition Analysis',
    price: 450
  },
  'microbiome': {
    id: '52258886516949',
    name: 'Microbiome Analysis',
    price: 650
  },
  'hormone': {
    id: '52260179869909',
    name: 'Hormone Panel',
    price: 500
  },
  'allergy': {
    id: '52260297539797',
    name: 'Food Allergy Testing',
    price: 350
  },
  'heavy-metals': {
    id: '52260603363541',
    name: 'Heavy Metals Panel',
    price: 250
  },
  'mold': {
    id: '52264697659605',
    name: 'Mold Exposure Screening',
    price: 350
  },
  'environmental': {
    id: '52275646562517',
    name: 'Environmental Toxins',
    price: 350
  },
  'mitome': {
    id: '52802861629653',
    name: 'Mitome Mitochondrial Analysis',
    price: 0
  },
  'wgs': {
    id: '52264703525077',
    name: 'Whole Genome Sequencing',
    price: 0
  },
  
  // Imaging (Step 2)
  'dexa': {
    id: '52270829764821',
    name: 'DEXA Body Composition',
    price: 50
  },
  'mri': {
    id: '52270831108309',
    name: 'Full-Body MRI',
    price: 50
  },
  'cardiac': {
    id: '52271251980501',
    name: 'Cardiac Calcium Score',
    price: 50
  },
  
  // Biometrics (Step 3)
  'vo2': {
    id: '52271623667925',
    name: 'VO2 Max Testing',
    price: 50
  },
  'rmr': {
    id: '52271662366933',
    name: 'Resting Metabolic Rate',
    price: 50
  },
  'wearable': {
    id: '52271676817621',
    name: 'Wearable Data Analysis',
    price: 50
  },
  'biometric-package': {
    id: '52271678947541',
    name: 'Complete Biometric Package',
    price: 125
  },
  
  // Consultation (Step 4)
  'written': {
    id: '52271686123733',
    name: 'Written Analysis Only',
    price: 150
  },
  'consult-30': {
    id: '52271689728213',
    name: '30-Minute Strategic Session',
    price: 250
  },
  'consult-60': {
    id: '52271691268309',
    name: '60-Minute Strategic Session',
    price: 475
  },
  'no-consult': {
    id: '52271692841173',
    name: 'No Strategic Session',
    price: 0
  },
  
  // Special Add-On
  'wgs-deep': {
    id: '52271696609493',
    name: 'WGS Deep Dive Analysis',
    price: 250
  }
};

// Track selected items
let selectedItems = [];
let totalPrice = 0;

// Set up checkbox change listeners
function setupCheckboxListeners() {
  console.log('Setting up checkbox listeners...');
  Object.keys(productMap).forEach(checkboxId => {
    const checkbox = document.getElementById(checkboxId);
    if (checkbox) {
      console.log('Found checkbox:', checkboxId);
      checkbox.addEventListener('change', handleCheckboxChange);
    } else {
      console.log('Checkbox not found:', checkboxId);
    }
  });
}

// Handle checkbox change
function handleCheckboxChange(event) {
  const checkboxId = event.target.id;
  const product = productMap[checkboxId];
  
  console.log('Checkbox changed:', checkboxId, 'Checked:', event.target.checked);
  
  if (!product) return;

  if (event.target.checked) {
    // Add to selection
    selectedItems.push({
      id: product.id,
      name: product.name,
      price: product.price,
      variantId: product.id
    });
    console.log('Added item:', product.name);
  } else {
    // Remove from selection
    selectedItems = selectedItems.filter(item => item.id !== product.id);
    console.log('Removed item:', product.name);
  }

  updateSummary();
}

// Update the summary sidebar
function updateSummary() {
  const summaryContent = document.getElementById('summary-content');
  const totalPriceEl = document.getElementById('total-price');

  console.log('Updating summary...', 'Items:', selectedItems.length);

  if (!summaryContent || !totalPriceEl) {
    console.error('Summary elements not found!');
    return;
  }

  // Calculate total
  totalPrice = selectedItems.reduce((sum, item) => sum + item.price, 0);

  // Update display
  if (selectedItems.length === 0) {
    summaryContent.innerHTML = '<p style="text-align: center; color: rgba(255,255,255,0.5); font-size: 1.7rem;">Select services to see your custom package</p>';
    totalPriceEl.textContent = 'Total: $0';
  } else {
    let html = '<ul style="list-style: none; padding: 0; margin: 0;">';
    selectedItems.forEach(item => {
      html += `
        <li style="padding: 1.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; align-items: center;">
          <span style="color: rgba(255,255,255,0.9); font-size: 1.6rem;">${item.name}</span>
          <span style="color: #00D4FF; font-weight: 700; font-size: 1.7rem;">$${item.price}</span>
        </li>
      `;
    });
    html += '</ul>';
    summaryContent.innerHTML = html;
    totalPriceEl.textContent = `Total: $${totalPrice.toLocaleString()}`;
  }
  
  console.log('Summary updated. Total:', totalPrice);
}

// Set up Add to Cart button
function setupAddToCartButton() {
  // Find the button by its text content
  const buttons = document.querySelectorAll('.btn');
  let addToCartBtn = null;
  
  buttons.forEach(btn => {
    if (btn.textContent.trim().includes('Add Selections to Cart')) {
      addToCartBtn = btn;
    }
  });
  
  console.log('Add to cart button found:', !!addToCartBtn);
  
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', addToCart);
    console.log('Event listener attached to Add to Cart button');
  } else {
    console.error('Could not find Add Selections to Cart button');
  }
}

// Add selected items to Shopify cart
async function addToCart(event) {
  event.preventDefault();

  console.log('Add to cart clicked. Items:', selectedItems.length);

  if (selectedItems.length === 0) {
    alert('Please select at least one item to add to your cart.');
    return;
  }

  // Prepare items for Shopify cart
  const items = selectedItems.map(item => ({
    id: item.variantId,
    quantity: 1
  }));

  console.log('Adding items to cart:', items);

  try {
    // Add to Shopify cart using Ajax API
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items })
    });

    if (response.ok) {
      console.log('Items added to cart successfully');
      // Success! Redirect to cart
      window.location.href = '/cart';
    } else {
      const errorData = await response.json();
      console.error('Cart API error:', errorData);
      throw new Error('Failed to add items to cart');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    alert('There was an error adding items to your cart. Please try again or contact support.');
  }
}

// Initialize everything
function init() {
  console.log('🔥 Ember8 Modular Cart - Initializing with VARIANT IDs...');
  setupCheckboxListeners();
  setupAddToCartButton();
  updateSummary();
  console.log('✅ Initialization complete');
}

// Run initialization when page loads
console.log('ember8-modular.js loaded, document ready state:', document.readyState);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Backup: Also try window.onload
window.addEventListener('load', function() {
  console.log('Window loaded event fired');
  const testCheckbox = document.getElementById('essential');
  if (testCheckbox && testCheckbox.onclick === null) {
    console.log('Checkboxes not set up, running init again...');
    init();
  }
});